module.exports = __webpack_public_path__ + "img/uitleg-stemdemo@small.6f8e8963.png";